import React from "react"
// import { render } from "react-dom"
// import { Formik, Field } from "formik"

const FormikCheckbox = ({
  field: { name, value, onChange, onBlur },
  form: { errors, touched, setFieldValue },
  id,
  label,
  className,
  disabled,
  ...props
}) => {
  return (
    <div className={className}>
    <label className="input">
    <input
    name={name}
    id={id}
    type="checkbox"
    value={value}
    checked={value}
    onChange={onChange}
    onBlur={onBlur}
    className="input__field"
    disabled={disabled}
    />
    <span className="input__text">{label}</span>
    </label>
</div>
  );
};



export default FormikCheckbox;
